<nz-card nzTitle="Element History Log" [nzExtra]="extraTemplate">
  <ng-container *ngIf="error$ | async as errorMsg; else resultComments">
    <nz-result
      nzStatus="error"
      nzTitle="SharePoint gave an error"
      [nzSubTitle]="errorMsg"
    ></nz-result>
  </ng-container>

  <ng-template #extraTemplate>
    <!-- Use stopPropagation so the panel doesn't toggle when clicking the link -->
    <a
      target="_blank"
      rel="external"
      [href]="siteUrl"
      (click)="$event.stopPropagation()"
      style="margin-left: 8px"
    >
      <i nz-icon nzType="link"></i>
      Open SharePoint Site
    </a>
  </ng-template>
</nz-card>

<ng-template #resultComments>
  <nz-skeleton [nzActive]="true" [nzLoading]="(designLoading$ | async) ?? false">
    <em-comment-list
      [comments]="(elementHistoryLogs$ | async) ?? []"
      [pageIndex]="(pageIndex$ | async) ?? 0"
      [pageSize]="(pageSize$ | async) ?? 0"
      [loading]="(elementHistoryLogLoading$ | async) ?? false"
      [totalComments]="(elementHistoryLogSize$ | async) ?? 0"
      (changePage)="changePage($event)"
      (changePageSize)="changePageSize($event)"
    ></em-comment-list>
  </nz-skeleton>
</ng-template>
